import { render, staticRenderFns } from "./VerificationOptions.vue?vue&type=template&id=7736399a&scoped=true&"
import script from "./VerificationOptions.vue?vue&type=script&lang=js&"
export * from "./VerificationOptions.vue?vue&type=script&lang=js&"
import style0 from "./VerificationOptions.vue?vue&type=style&index=0&id=7736399a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7736399a",
  null
  
)

export default component.exports